import { handleActions } from 'redux-actions';
import BlacklineCache from 'models/data/blackline-cache-model';
import { resetCurrentBlacklineCache } from '../../../actions/blackline-view-actions';
import {
  currentBlacklineViewChangesLoading,
  currentBlacklineViewChangesLoaded,
  currentBlacklineViewChangesError,
} from '../../../actions/blackline-view-action-creator';
import { clearCurrentBlacklineContentWithIdsFromCache } from '../../../actions/section-cache-actions';

export default handleActions(
  {
    [currentBlacklineViewChangesLoading]: (
      currentBlacklineCache,
      { payload },
    ) => {
      return currentBlacklineCache.setSectionLoading(payload);
    },
    [currentBlacklineViewChangesLoaded]: (
      currentBlacklineCache,
      { payload },
    ) => {
      return currentBlacklineCache.setSectionLoaded(payload);
    },
    [currentBlacklineViewChangesError]: (
      currentBlacklineCache,
      { payload },
    ) => {
      return currentBlacklineCache.setSectionError(payload);
    },
    [resetCurrentBlacklineCache]: () => {
      return new BlacklineCache();
    },
    [clearCurrentBlacklineContentWithIdsFromCache]: (
      currentBlacklineCache,
      { payload },
    ) => {
      return currentBlacklineCache.clearSectionBySectionIds(payload);
    },
  },
  new BlacklineCache(),
);
